module.exports = __webpack_public_path__ + "static/media/m-pesa.a144fad4.svg";